import styles from './FormModule.module.scss'
import { Form, Heading } from '~elements'
import { FormProps, AssetType, ModalViewFormSubmitProps } from '~types'
import { Container } from 'react-grid-system'
import Image from 'next/image'

import cx from 'classnames'
import { NEXT_IMAGE_QUALITY } from '~constants'

interface FormModuleProps {
  headline: string
  form: FormProps
  formModuleId: string
  backgroundImage: AssetType
  successModal: ModalViewFormSubmitProps
  narrowForm: boolean
  headingLevel: number
  floatingLabel: boolean
}

const FormModule = ({
  headline,
  form,
  formModuleId,
  backgroundImage,
  successModal,
  narrowForm = false,
  floatingLabel = false
}: FormModuleProps) => {
  const imageContainerClassName = cx(styles['image-container'], { [styles['relative-mobile']]: narrowForm })

  const formModuleClassName = cx([styles['form-module'], styles[narrowForm ? 'narrow-form' : 'full-width-form']])

  // if the background image is an SVG we need to add the unoptimized prop
  const isSvg = backgroundImage?.fileName?.endsWith('.svg')
  return (
    <div className={formModuleClassName}>
      <div className={imageContainerClassName}>
        {narrowForm && <div className={styles['media-overlay']} />}
        {backgroundImage?.url && (
          <Image
            src={backgroundImage.url}
            alt={backgroundImage?.altText ?? ''}
            fill
            quality={!isSvg ? NEXT_IMAGE_QUALITY : undefined}
            unoptimized={isSvg}
          />
        )}
      </div>

      <div className={styles[`form-module-container`]} id={formModuleId}>
        <Container className={cx([styles['container']])}>
          {headline && (
            <Heading level='2' noMarginTop>
              {headline}
            </Heading>
          )}
          <Form
            formId={form?.formId}
            submitButtonText='Submit'
            successModalView={successModal?.view}
            floatingLabel={floatingLabel}
            narrowForm={narrowForm}
          />
        </Container>
      </div>
    </div>
  )
}

export default FormModule
